<template>
  <div class="ask-gpt-builder-component ask-gtp-task-wrapper">
    <div class="modal task fancy-scroll" @scroll.passive="showScrollbar">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">gpt task</div>
      <div v-if="!loading" class="content ask-gpt-builder-component">
        <div class="ask-gpt-page-wrapper">
          <div class="ask-gpt-page-header col-4">
            <b-form-input
              v-model.trim="task.props.chatGptTaskName"
              placeholder="Dateinamen"
              :class="{ 'is-duplicate': isNameDuplicate, error: isNameShaking }"
              :disabled="!isUserHasAccess"
            ></b-form-input>
          </div>

          <CustomDropdown
            class="ai-model-dropdown"
            :disabled="!isUserHasAccess"
          >
            <template v-slot:selected-option>
              <span class="line-clamp"
                >{{ task.props.model || 'gpt-3.5-turbo' }}
              </span>
            </template>
            <template v-slot:option-data>
              <b-dropdown-item @click="toogleVersion('gpt-4')"
                >GPT-4</b-dropdown-item
              >
              <b-dropdown-item @click="toogleVersion('gpt-3.5-turbo')"
                >GPT-3.5-TURBO
              </b-dropdown-item>
            </template>
          </CustomDropdown>

          <div class="chatgpt-item">
            <div v-if="!callingApi" class="round-button" @click="askChatGpt">
              <i class="fas fa-play"></i>
            </div>
            <b-spinner v-else class="call-spinner" label="Spinning"></b-spinner>
          </div>
        </div>
        <div class="chatgpt-wrapper">
          <div class="chatgpt-wrapper-inner">
            <div class="input-wrap">
              <textarea
                class="fancy-scroll"
                @scroll.passive="showScrollbar"
                ref="prompt-text"
                type="text"
                placeholder="Stellen Sie Ihre Frage hier…"
                v-model="task.props.prompt"
                rows="5"
                :disabled="!isUserHasAccess"
              />
            </div>
            <hr />
            <div
              class="answer-wrapper fancy-scroll"
              @scroll.passive="showScrollbar"
            >
              <h1 class="text-left">Antwort:</h1>
              <p>{{ chatGptResponse }}</p>
            </div>
          </div>
        </div>

        <div class="tools data-tools">
          <div class="element" v-if="isAttachFileVisible">
            <div class="button" @click.stop="toggleAttacheFile">
              <svg
                width="18px"
                height="18px"
                x="0px"
                y="0px"
                viewBox="0 0 607.983 607.983"
              >
                <g>
                  <g>
                    <path
                      d="M112.682,572.01c23.18,23.198,56.648,35.974,94.234,35.974c46.082,0,92.125-18.541,123.161-49.61L581.403,307.09
                        c0,0,6.152-6.942,6.152-16.92c0-13.517-10.957-24.471-24.469-24.471c-7.162,0-13.547,3.132-18.021,8.033L295.226,523.532
                        c-21.511,21.545-56.271,35.463-88.553,35.463c-17.036,0-41.119-3.792-59.14-21.836l-56.299-56.3
                        c-37.093-37.093-22.869-111.116,13.631-147.678l267.88-267.851c10.369-10.38,24.174-16.099,38.871-16.099
                        s28.5,5.718,38.871,16.104l47.402,47.363c21.404,21.473,21.404,56.352,0.004,77.753L272.668,415.644
                        c-13.646,13.67-28.435,21.19-41.654,21.19c-9.912,0-19.054-4.126-27.187-12.264c-9.95-9.955-9.95-17.088-9.95-32.714
                        c0-14.664,5.723-28.467,16.108-38.871L406.95,156.041c0,0,5.789-5.375,5.789-16.773c0-13.517-10.959-24.47-24.471-24.47
                        c-7.75,0-14.572,3.672-19.057,9.29L175.135,318.135c-19.679,19.713-30.523,45.896-30.542,73.718
                        c0,26.636,4.083,47.229,24.389,67.559c17.294,17.294,38.518,26.436,61.387,26.431c26.98,0,54.382-12.556,77.15-35.357
                        l225.227-225.187c40.648-40.646,40.648-106.79,0-147.444l-47.406-47.368C465.676,10.825,439.495,0,411.616,0
                        s-54.062,10.825-73.723,30.485L70.024,298.335c-31.054,31.021-49.596,77.059-49.596,123.161c0,37.59,12.771,71.054,35.955,94.214
                        L112.682,572.01z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="info-wrapper" v-show="!tools.attache.show">
              <div class="info">Datei anhängen</div>
            </div>
            <div
              class="toggle-list-wrapper files"
              v-if="tools.attache.show"
              v-click-outside="hideAttacheFile"
            >
              <div class="file-type-size-tooltip">
                <CustomTooltip
                  targetId="description"
                  iconSlotName="icon-slot"
                  toolTipCustomClass="supported-file-type"
                  placement="bottom"
                >
                  <template v-slot:icon-slot>
                    <i
                      class="fa fa-question-circle fa-2x icon"
                      id="description"
                    ></i>
                  </template>
                  <template v-slot:tooltip-content>
                    <div class="tooltip_wrapper">
                      <span>Die maximale Dateigröße beträgt 512 MB</span>
                      <span>Unterstützter Dateityp:</span>
                      <ul>
                        <li
                          v-for="fileType in getSupportedFileTypes"
                          :key="fileType"
                        >
                          <p>{{ fileType }}</p>
                        </li>
                      </ul>
                    </div>
                  </template>
                </CustomTooltip>
              </div>
              <div
                v-for="(f, index) in files"
                :key="index"
                class="item"
                :class="{ checked: f.selected }"
                :disabled="!isUserHasAccess"
                :id="`file-${f.name}-${index}`"
              >
                <CustomTooltip
                  v-if="isFileTypeSupported(f).isVisible"
                  :targetId="`file-${f.name}-${index}`"
                  :tooltipText="isFileTypeSupported(f).message"
                  iconSlotName="empty"
                >
                </CustomTooltip>
                <img class="logo" :src="getImgUrl('./file-icon.png')" />
                <div class="label">{{ f.name }}</div>
                <div class="check-box" @click="attacheFile(f)">
                  <svg width="26" height="15" class="icon">
                    <rect x="0" y="0" />
                    <g>
                      <g>
                        <rect
                          x="65.38988800054005"
                          y="111.28423827474339"
                          width="61.04743778705597"
                          height="237"
                          transform="matrix(0.027894680951674893,-0.02301867936171278,0.01967084489978093,0.0326421523831461,-4.013084678766421,5.249976641417972) "
                        />
                        <rect
                          x="305.0431614702238"
                          y="-96.1089254879951"
                          width="62.20270872116089"
                          height="558.1124589443208"
                          transform="matrix(0.01917799119807895,0.03304131945959807,-0.028235793207795276,0.022441945551370072,11.382479318709576,-7.922156200173908) "
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="element">
            <div class="button" @click.stop="toggleInputDataFields">
              <svg
                width="24px"
                height="24px"
                x="0px"
                y="0px"
                viewBox="0 0 450 600"
                class="data-fields"
              >
                <g>
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    id="svg_20"
                    x="321.42857360839844"
                    y="328.7261941432953"
                    width="226"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="322.1230182647705"
                    y="327.4761941432953"
                    width="226"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_29"
                    transform="rotate(89.70001220703125 435.1231689453125,342.4761657714844) "
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="-0.17856436967849731"
                    y="233.25000143051147"
                    width="351.9325393145858"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_28"
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="0"
                    y="0.75"
                    width="403.32143771648407"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_32"
                  />
                  <rect
                    fill
                    stroke-dashoffset
                    fill-rule="nonzero"
                    x="0"
                    y="117.03968334197998"
                    width="404.2142987717938"
                    height="30"
                    style="color: rgb(0, 0, 0)"
                    class
                    id="svg_30"
                  />
                </g>
              </svg>
            </div>
            <div class="info-wrapper" v-if="!isShowInputDataField">
              <div class="info">Daten einfügen</div>
            </div>
            <div
              v-if="isShowInputDataField"
              class="toggle-list-wrapper data-fields"
              v-click-outside="toggleInputDataFields"
            >
              <div class="search">
                <span class="search-icon"></span>
                <input
                  name="search"
                  v-model="inputDataSearchText"
                  placeholder="Suchbegriff"
                />
              </div>
              <div
                class="data-fields-content fancy-scroll"
                @scroll.passive="showScrollbar"
              >
                <div
                  v-for="(field, index) in filterInputDataFields"
                  :key="index"
                  class="item"
                  @click="insertInputData(field.name)"
                >
                  <div class="label">{{ field.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="attachment"
          v-if="toogleChatgptVersion && files && files.length > 0"
        >
          <div
            v-for="(f, index) in task.props.attachment"
            :key="index"
            class="item"
          >
            <div class="attachment-item">
              <div
                class="btn-close"
                v-if="isUserHasAccess"
                @click="removeAttachment(f.name)"
              ></div>
              <img class="logo" v-bind:src="getImgUrl('./file-icon.png')" />
              <div class="label">
                {{ f.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-container" v-if="loading">
        <LoadingSpinner loadingCaption="Wird gespeichert..." />
      </div>
    </div>
  </div>
</template>

<script>
import { askChatGPT } from '../../services/workflow.service';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import {
  getApiEndpointVersion,
  isValidTaskName,
  debouncer,
  getInputPlaceholderList,
  LATEST_FLOW_RUNNER_VERSION,
} from '@/utils/helpers';
import { getDefaultTaskName } from '@/utils/helpers/WorkFlowHelpers.js';

import { flattenInputObjectFields } from '@/utils/helpers.js';

import CustomDropdown from '../widgets/CustomDropdown.vue';

import CustomTooltip from '@/components/CustomTooltip.vue';
export default {
  name: 'AskChatGPT',
  data() {
    return {
      loading: false,
      callingApi: false,
      isNameShaking: false,
      chatGptResponse: null,
      isShowInputDataField: false,
      inputDataSearchText: null,
      toogleChatgptVersion: false,
      tools: {
        attache: {
          show: false,
        },
      },
    };
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    process: {
      type: Object,
      required: true,
    },
    getFileNamesFromProps: {
      type: Function,
      required: true,
      default: () => {},
    },
    isUserHasAccess: { type: Boolean, default: true },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  created() {
    if (!this.task.props.chatGptTaskName) {
      const existingTaskNames = this.getFileNamesFromProps(this.task.id);
      this.task.props.chatGptTaskName = getDefaultTaskName(
        existingTaskNames,
        'ChatGPT_Antwort'
      );
    }
  },
  methods: {
    close() {
      if (
        !this.isNameDuplicate &&
        isValidTaskName(this.task.props.chatGptTaskName)
      ) {
        this.loading = true;
        if (this.chatGptResponse) {
          this.task.output = [
            {
              label: this.task.props.chatGptTaskName,
              name: this.task.props.chatGptTaskName,
              type: 'text',
              value: this.chatGptResponse,
            },
          ];
          this.$set(
            this.task,
            'output',
            this.task.output.concat(this.task.input)
          );
        } else {
          this.$set(this.task, 'output', this.task.input);
        }

        this.loading = false;
        this.$emit('close');
      } else {
        this.isNameShaking = true;
        setTimeout(() => {
          this.isNameShaking = false;
        }, 500);
      }
    },
    async askChatGpt() {
      if (!this.task.props.prompt) return;
      this.callingApi = true;

      let newPrompt = this.task.props.prompt;
      this.task.input.forEach((el) => {
        newPrompt = newPrompt?.replaceAll(`{${el.name}}`, el.value);
        newPrompt = newPrompt?.replaceAll(`{ ${el.name} }`, el.value);
      });
      // As flowrunner expects only first task, remove other tasks
      // and clear output
      let f = JSON.parse(JSON.stringify(this.process));
      f.tasks = [f.tasks[0]];
      f.tasks[0].output = [];
      // Put props and input in form data

      try {
        const url = this.flowRunnerEndpoint;
        let res;
        if (getApiEndpointVersion(url) >= 6) {
          const formData = new FormData();
          formData.append(
            'props',
            JSON.stringify({ prompt: newPrompt, model: this.task.props.model })
          );
          // Add only files when only chatgpt 4
          if (
            this.toogleChatgptVersion &&
            this.task.input &&
            this.task.props.attachment.length > 0
          ) {
            this.task.props.attachment.forEach((attched) => {
              this.task.input.forEach((e) => {
                if (e.type == 'file' && attched.name == e.name)
                  formData.append(e.name, e.value);
              });
            });
          }
          res = await askChatGPT(url, formData);
        } else {
          res = await askChatGPT(url, { prompt: this.task.props.prompt });
        }
        this.chatGptResponse = res.data.message;
      } catch (error) {
        console.log(error);
      }
      this.callingApi = false;
    },
    toggleInputDataFields() {
      this.isShowInputDataField = !this.isShowInputDataField;
      this.hideAttacheFile();
    },
    insertInputData(content) {
      const el = this.$refs['prompt-text'];
      const [start, end] = [el.selectionStart, el.selectionEnd];

      if (start !== end) {
        el.setRangeText(`{${content}} `, start, end, 'select');
      }

      if (start === end) {
        el.value += `{${content}}`;
      }

      this.task.props.prompt = el.value;
    },
    updateToggleVersion() {
      if (this.task.props.model === 'gpt-3.5-turbo') {
        this.toogleChatgptVersion = false;
      } else this.toogleChatgptVersion = true;
    },
    toogleVersion(model) {
      this.task.props.model = model;
      this.updateToggleVersion();
    },
    isAttached(file) {
      return (
        this.task.props.attachment.filter((f) => f.name == file.name).length > 0
      );
    },
    toggleAttacheFile() {
      this.tools.attache.show = !this.tools.attache.show;
      this.hideInputDataField();
    },

    getImgUrl(img) {
      var images = require.context('../../assets/img/', false, /\.png$/);
      return images(img);
    },
    getFileInput(file) {
      return this.task.input.find(
        (input) => input.type == 'file' && input.name == file.name
      );
    },
    isFileTypeSupported(file) {
      const currentInput = this.getFileInput(file);
      if (!currentInput) return false;
      const fileSizeLimitInKB = 512000;

      let isVisible = false;
      let message = '';

      if (!this.getSupportedFileTypes.includes(currentInput?.value?.type)) {
        isVisible = true;
        message = 'Das Dateiformat wird nicht unterstützt';
      }
      if (currentInput?.value?.size / 1000 > fileSizeLimitInKB) {
        isVisible = true;
        message += ' Diese Datei ist zu groß';
      }

      return { isVisible, message };
    },
    attacheFile(file) {
      if (!this.isUserHasAccess) return;
      // check is file type is supported or not
      if (this.isFileTypeSupported(file).isVisible) return;
      const currentInput = this.getFileInput(file);

      if (file.selected) this.removeAttachment(file.name);
      else this.addAttachment(file);
      this.showAttacheFile();
    },
    hideAttacheFile() {
      this.tools.attache.show = false;
    },
    hideInputDataField() {
      this.isShowInputDataField = false;
    },
    addAttachment(file) {
      this.task.props.attachment.push({ name: file.name, label: file.label });
    },
    showAttacheFile() {
      this.tools.attache.show = true;
    },
    removeAttachment(name) {
      if (!this.isUserHasAccess) return;
      this.task.props.attachment = this.task.props.attachment.filter(
        (f) => f.name != name
      );
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
  },
  computed: {
    inputDataFields() {
      const fieldsToFiltered = ['file', 'filenew', 'model', 'dataframe'];
      const apiVersion =
        getApiEndpointVersion(this.flowRunnerEndpoint) ||
        LATEST_FLOW_RUNNER_VERSION;
      return getInputPlaceholderList(
        this.task.input,
        apiVersion,
        fieldsToFiltered
      );
    },
    filterInputDataFields() {
      return this.inputDataFields.filter((field) => {
        if (this.inputDataSearchText)
          return (
            field.name
              .toLowerCase()
              .indexOf(this.inputDataSearchText.toLowerCase()) > -1
          );
        else return this.inputDataFields;
      });
    },
    isNameDuplicate() {
      const chatGptTaskNames = this.getFileNamesFromProps(this.task.id);
      return (
        chatGptTaskNames.includes(this.task.props.chatGptTaskName) ||
        !this.task.props.chatGptTaskName
      );
    },
    files() {
      let files = [];

      this.task.input.forEach((e) => {
        if (
          (e.type == 'file' && e.value instanceof File) ||
          e.type == 'filenew'
        ) {
          files.push({
            name: e.name,
            selected: this.isAttached(e),
          });
        }
      });
      return files;
    },
    user() {
      return this.$store.state.user;
    },
    getFlowRunnerUrlVersion() {
      return getApiEndpointVersion(this.flowRunnerEndpoint);
    },
    isAttachFileVisible() {
      return (
        this.getFlowRunnerUrlVersion &&
        this.getFlowRunnerUrlVersion >= 6 &&
        this.toogleChatgptVersion &&
        this.files &&
        this.files.length > 0
      );
    },
    // supported types for chat gpt api
    getSupportedFileTypes() {
      return [
        'text/x-c',
        'text/x-c++',
        'text/x-csharp',
        'text/css',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/x-golang',
        'text/html',
        'text/x-java',
        'text/javascript',
        'application/json',
        'text/markdown',
        'application/pdf',
        'text/x-php',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'text/x-python',
        'text/x-script.python',
        'text/x-ruby',
        'application/x-sh',
        'text/x-tex',
        'application/typescript',
        'text/plain',
      ];
    },
  },
  mounted() {
    this.updateToggleVersion();
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  components: {
    LoadingSpinner,
    CustomDropdown,
    CustomTooltip,
  },
};
</script>

<style scoped>
.ask-gtp-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ask-gpt-builder-component .call-spinner {
  margin: auto;
}
.ask-gpt-builder-component .round-button {
  width: 42px;
  height: 42px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 17px;
  color: #2c3e50;
  cursor: pointer;
  border: 1px solid #d2d2d2;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
}

.ask-gpt-builder-component .content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.ask-gpt-builder-component .pull-right {
  float: right;
  position: absolute;
  top: 1%;
  right: 0%;
}

.ask-gpt-builder-component .btn-close {
  position: relative;
  z-index: 9;
  top: 10px;
  right: 5px;
  padding: 10px 10px;
}

.ask-gpt-builder-component .progress-icon-wrapper {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.ask-gpt-builder-component .progress-icon-wrapper .progress-icon {
  left: unset;
  margin: 0 auto;
  top: unset;
  margin-top: 30px;
}
.ask-gpt-builder-component .progress-icon-wrapper .progress-icon:after {
  border-color: #313745 transparent #313745 transparent;
}

/*New added*/

.ask-gpt-builder-component .chatgpt-wrapper {
  margin-top: 36px;
  height: calc(100% - 38px - 36px);
  width: 100%;
  min-height: 300px;
  display: flex;
}

.ask-gpt-builder-component .content.ask-gpt-builder-component {
  height: calc(100% - 36px - 17px);
  margin-top: 17px;
}

.ask-gpt-builder-component .chatgpt-wrapper .input-wrap textarea {
  font-size: 33px;
  color: #a3a2a2;
  margin-bottom: 20px;
  width: 100%;
  height: 100%;
  line-height: 35px;
  border: none;
  resize: none !important;
}
.ask-gpt-builder-component .chatgpt-wrapper .input-wrap textarea::placeholder {
  color: #a3a2a2;
}
.ask-gpt-builder-component .chatgpt-wrapper .input-wrap textarea:focus-visible {
  outline: none;
}

.ask-gpt-builder-component .chatgpt-wrapper .message-alert {
  padding: 12px;
  background: rgb(163 163 163 / 20%);
  border-radius: 6px;
  color: #838181;
  font-size: 14px;
}
.ask-gpt-builder-component .chatgpt-item {
  position: absolute;
  left: 36px;
  top: 32px;
}
.ask-gpt-builder-component .chatgpt-wrapper-inner {
  width: 100%;
  height: 100%;
}
.ask-gpt-builder-component .chatgpt-wrapper .input-wrap {
  height: 60%;
}

.ask-gpt-builder-component .chatgpt-wrapper .answer-wrapper h1 {
  font-size: 33px;
  color: #333343;
}
.ask-gpt-builder-component .search {
  width: 200px;
  padding: 5px 0 26px 0;
  height: 21px;
  margin-left: 12px;
  border-bottom: solid 1px #bdc3c7;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.ask-gpt-builder-component .search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 23px;
  overflow: hidden;
  display: block;
  width: 24px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
}

.ask-gpt-builder-component .search input {
  border: 0;
  width: 85%;
  margin-left: 5px;
  height: 20px;
  padding: 4px 4px !important;
  cursor: initial;
  padding-top: 11px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  margin-bottom: 0;
  box-sizing: border-box;
  outline: none;
}
.ask-gpt-builder-component .modal.task .tools.data-tools {
  position: absolute !important;
  top: 40% !important;
  right: 36px !important;
}
.ask-gpt-builder-component .answer-wrapper p {
  margin: 0;
  font-size: 33px;
  line-height: normal;
}

.ask-gpt-builder-component .answer-wrapper {
  height: calc(40% - 31px);
  overflow: auto;
}
.ask-gpt-builder-component .ask-gpt-page-wrapper {
  max-width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0;
}

.ask-gpt-builder-component .ask-gpt-page-header input {
  font-size: 15px !important;
  line-height: 28px !important;
  cursor: text !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  color: #000 !important;
  border: 1px solid #e2e2e2 !important;
  border-radius: 6px !important;
  padding: 12px 12px !important;
  height: 38px !important;
}

.ask-gpt-builder-component .ask-gpt-page-header input:focus {
  outline: none;
  box-shadow: none;
}

.ask-gpt-builder-component .ask-gpt-page-header input::placeholder {
  color: #8b8b8b;
}
.ask-gpt-builder-component .is-duplicate {
  background: #ff050578;
}
@keyframes shake {
  0% {
    margin-left: 0rem;
  }
  25% {
    margin-left: 0.5rem;
  }
  75% {
    margin-left: -0.5rem;
  }
  100% {
    margin-left: 0rem;
  }
}
.ask-gpt-builder-component .error {
  animation: shake 0.2s ease-in-out 0s 2;
  border: none;
  box-shadow: 0 0 0.5em red;
}

.ask-gpt-page-wrapper .switch-group {
  gap: 30px;
  display: flex;
  align-items: center;
}
.ask-gpt-page-wrapper .switch-group > label.caption {
  color: #333343;
  margin: 0;
  font-size: 21px;
  font-weight: 500;
  white-space: pre;
  text-transform: uppercase;
}

.ask-gpt-page-wrapper .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.ask-gpt-page-wrapper .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ask-gpt-page-wrapper .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.ask-gpt-page-wrapper .slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.ask-gpt-page-wrapper input:checked + .slider {
  background-color: #000;
}

.ask-gpt-page-wrapper input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.ask-gpt-page-wrapper .slider.round {
  border-radius: 34px;
}

.ask-gpt-page-wrapper .slider.round:before {
  border-radius: 50%;
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
}

.col-3 .pull-right {
  margin-right: 0px;
  margin-top: 5px;
}
.ask-gpt-page-wrapper .switch-toogle {
  position: relative;
}

.toggle-list-wrapper.data-fields .item .label {
  line-height: 41px;
}
.logo {
  width: 35px;
  margin-top: 0;
}
.check-box {
  border-style: solid;
  height: 16px;
  width: 16px;
  position: absolute;
  top: 8px;
  left: 8px;
  border-width: 1px;
  border-color: var(--color-black);
  background-color: #ffff;
  transition: all 0.3s ease-out;
  border-radius: 50%;
}

.check-box .icon {
  fill: #ffff;
  zoom: 0.6;
  padding-top: 0;
  padding-left: 3px;
}

.item.checked .check-box {
  background-color: var(--color-black);
}
.attachment {
  overflow: auto;
  margin-right: 0;
  display: block;
  max-width: 300px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: auto;
  margin-left: 0;
  text-align: right;
  cursor: auto;
  right: 75px;
  box-sizing: border-box;
  width: auto;
}
.attachment .item {
  cursor: auto;
  padding: 8px;
  width: 75px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
}

.attachment .item .label {
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  color: #596377;
}

.ask-gtp-task-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
.ask-gtp-task-wrapper .data-fields-content {
  overflow-y: auto;
  height: 190px;
}
[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.ask-gtp-task-wrapper .ai-model-dropdown {
  width: 180px;
}
.ask-gtp-task-wrapper .ai-model-dropdown ::v-deep .custom-dropdown-toggle {
  height: 38px;
}
.ask-gtp-task-wrapper .ai-model-dropdown .line-clamp {
  text-transform: uppercase;
}
.ask-gtp-task-wrapper .ai-model-dropdown ::v-deep .dropdown-item {
  color: black;
}

.ask-gpt-builder-component .file-type-size-tooltip {
  display: flex;
  justify-content: end;
  position: absolute;
  right: 15px;
  z-index: 1;
}

.supported-file-type .tooltip-inner ul {
  text-align: left !important;
}

.supported-file-type .tooltip-inner ul p {
  margin: 0 !important;
}

.supported-file-type .tooltip-inner .tooltip_wrapper {
  max-height: 300px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.supported-file-type .tooltip-inner .tooltip_wrapper span {
  font-size: 14px;
  padding-top: 10px;
  padding-left: 10px;
  text-align: left;
}
</style>
